import React, { useState } from 'react';

import useIsMobile from 'hooks/use-is-mobile';
import Customers from 'pages/Landings/components/Customers';
import Layout from 'pages/Landings/components/Layout';
import Title from 'pages/Landings/components/Title';

import Period from './components/Period';
import Plans from './components/Plans';
import PriceEstimation from './components/PriceEstimation';
import Questions from './components/Questions';
import useStyles from './styles';
import { Period as PeriodType } from './types';

const Pricing: React.FC = () => {
    const { classes } = useStyles();
    const isMobile = useIsMobile();
    const [period, setPeriod] = useState(PeriodType.MONTHLY);

    return (
        <Layout>
            <Title variant={isMobile ? 'h1' : 'h2'} as={'h1'} className={classes.title}>
                {'Choose your plan'}
            </Title>
            <Period value={period} onChange={setPeriod} className={classes.period} />
            <Plans period={period} className={classes.plans} />
            <Customers className={classes.customers} title={{ align: 'left' }} />
            <PriceEstimation className={classes.estimation} />
            <Questions className={classes.questions} />
        </Layout>
    );
};

export default Pricing;
